export const CONFIRMATION = "confirmation";
export const ERROR = "error";
export const DATA = "data";
export const TRANSACTION_HASH = "transactionHash";
